<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template(v-if="settings.withTime && settings.showTime && parametersFrom === 'homework'")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
						| {{ settings.showTime }}
						| {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
						br
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}:
								| {{ $i18n.t('couples.couples_view_' + settings.viewType)  }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
								| {{ settings.difficult.amountOfRows + ' x ' + settings.difficult.amountOfColumns }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_order') }}:
								| {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.mode) }}
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        },
    }
</script>
